import CustomForm from "../CustomForm";
import m, {Vnode} from "mithril";
import ICustomFormSettings from "../ICustomFormSettings";
import {TextboxItem} from "../../model/items/textbox";
import {CheckboxItem} from "../../model/items/checkbox";

export default class PriceTest extends CustomForm {
    private readonly ci_teorMin: TextboxItem;
    private readonly ci_teorMax: TextboxItem;
    private readonly ci_startMin: TextboxItem;
    private readonly ci_startMax: TextboxItem;
    private readonly ci_stepUp: TextboxItem;
    private readonly ci_stepDown: TextboxItem;
    private readonly ci_startValue: TextboxItem;
    private readonly ci_current: TextboxItem;
    private readonly ci_progress: TextboxItem;
    private readonly ci_testMax: TextboxItem;
    private readonly ci_validation: CheckboxItem;
    private readonly ci_refuse: CheckboxItem;
    private readonly ci_reachTeorMin: CheckboxItem;

    private currentMax?: number;
    private currentMin?: number;

    constructor(settings: ICustomFormSettings) {
        super(settings);

        this.ci_teorMin = <TextboxItem>settings.form.grid.layout[5][1]?.cellItems.filter(ci => ci instanceof TextboxItem)[0];
        this.ci_teorMax = <TextboxItem>settings.form.grid.layout[6][1]?.cellItems.filter(ci => ci instanceof TextboxItem)[0];
        this.ci_startMin = <TextboxItem>settings.form.grid.layout[7][1]?.cellItems.filter(ci => ci instanceof TextboxItem)[0];
        this.ci_startMax = <TextboxItem>settings.form.grid.layout[8][1]?.cellItems.filter(ci => ci instanceof TextboxItem)[0];
        this.ci_stepUp = <TextboxItem>settings.form.grid.layout[9][1]?.cellItems.filter(ci => ci instanceof TextboxItem)[0];
        this.ci_stepDown = <TextboxItem>settings.form.grid.layout[10][1]?.cellItems.filter(ci => ci instanceof TextboxItem)[0];
        this.ci_startValue = <TextboxItem>settings.form.grid.layout[11][1]?.cellItems.filter(ci => ci instanceof TextboxItem)[0];
        this.ci_current = <TextboxItem>settings.form.grid.layout[12][1]?.cellItems.filter(ci => ci instanceof TextboxItem)[0];
        this.ci_progress = <TextboxItem>settings.form.grid.layout[13][1]?.cellItems.filter(ci => ci instanceof TextboxItem)[0];
        this.ci_testMax = <TextboxItem>settings.form.grid.layout[14][1]?.cellItems.filter(ci => ci instanceof TextboxItem)[0];
        this.ci_validation = <CheckboxItem>settings.form.grid.layout[15][0]?.cellItems.filter(ci => ci instanceof CheckboxItem)[0];
        this.ci_refuse = <CheckboxItem>settings.form.grid.layout[16][0]?.cellItems.filter(ci => ci instanceof CheckboxItem)[0];
        this.ci_reachTeorMin = <CheckboxItem>settings.form.grid.layout[17][0]?.cellItems.filter(ci => ci instanceof CheckboxItem)[0];

        if (!this.ci_testMax.getVariable()) {
            this.ci_testMax.setVariable(this.ci_teorMin.getVariable());
        }
    }

    checkRequirements(): boolean {
        const isOk = Boolean(this.ci_teorMin && this.ci_teorMax && this.ci_startMin && this.ci_startMax && this.ci_stepUp && this.ci_stepDown && this.ci_startValue && this.ci_current && this.ci_progress && this.ci_validation && this.ci_testMax && this.ci_refuse && this.ci_reachTeorMin);
        if (!isOk) {
            console.log('customForm-PriceTest: missing TextboxItem or CheckboxItem.');
            return false;
        }
        return super.checkRequirements();
    }

    private setPrice(price: number) {
        this.ci_current.set(price);
        this.ci_progress.set(this.ci_progress.getVariable() + ','+price);
    }
    private stepUp(): void {
        const step = Number(this.ci_stepUp.getVariable());
        const teor = Number(this.ci_teorMax.getVariable());
        const current = Number(this.ci_current.getVariable());
        const newPrice = Math.min(current+step, teor);

        this.ci_testMax.set(current);

        if (current === teor || this.currentMax && newPrice >= this.currentMax) {
            this.ci_validation.setVariable(true);
            this.settings.nextForm();
        } else {
            this.setPrice(newPrice);
            this.currentMin = current;
        }
    }

    private stepDown(): void {
        const step = Number(this.ci_stepDown.getVariable());
        const teor = Number(this.ci_teorMin.getVariable());
        const current = Number(this.ci_current.getVariable());
        const newPrice = Math.max(current-step, teor);

        this.ci_refuse.setVariable(true);
        if (current === teor) {
            this.ci_reachTeorMin.setVariable(true);
        }

        if (current === teor || this.currentMin && newPrice <= this.currentMin) {
            this.ci_validation.setVariable(true);
            this.settings.nextForm();
        } else {
            this.setPrice(newPrice);
            this.currentMax = current;
        }
    }

    rewriteFormControls(): boolean {
        return true;
    }

    public view(): Vnode {
        return this.viewLayout(
            m('.PriceTest', {}, [
                m('.PriceTest-value', {}, this.ci_current.getVariable()),
                m('.PriceTest-question', {}, `Byl/a bych ochoten/ochotna zaplatit ${this.ci_current.getVariable()} Kč?`),
                m('.PriceTest-controls', {}, [
                    m('button.btn.large.info.outline', {
                        onclick: () => this.stepUp(),
                    }, 'Ano'),
                    m('button.btn.large.info.outline', {
                        onclick: () => this.stepDown(),
                    }, 'Ne'),
                ])
            ]), null
        );
    }

}
